import { __awaiter } from "tslib";
import fetch from '../fetch';
import conf from '../../conf';
import { setHandshakeUserDetails, setPartnerConfig, setPartnerKey, setPartnerParams, } from '../../store/partner';
import { appendQueryParamToUrl } from '../../components/helpers/redirect';
import { openExternalLink } from '../helpers';
import { sanitizeReturnUrl } from '../../../shared/utils/url-validation';
export const checkIfPartnerFlowIsAuthorized = (partnerId, key, dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    return fetch(dispatch)(`${conf.API_URL}/api/handshake/${partnerId}`, {}, { Authorization: key !== null && key !== void 0 ? key : '' });
});
export const getPartnerConfig = (partnerId) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/partner/${partnerId}`);
    if (!result.ok)
        return;
    dispatch(setPartnerConfig(result.value));
});
export const setPartnerQueryParams = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const searchParams = new URLSearchParams(window.location.search);
    const partnerParams = {
        accountId: searchParams.get('accountId') || undefined,
        returnUrl: searchParams.get('returnUrl') || undefined,
        state: searchParams.get('state') || undefined,
    };
    dispatch(setPartnerParams(partnerParams));
});
export const getPartnerReturnUrl = ({ partnerState, accountId, crmId, error = false }) => {
    var _a, _b;
    const { partnerParams, handshakeUserDetails } = partnerState;
    const partnerReturnUrl = sanitizeReturnUrl((_b = (_a = partnerParams === null || partnerParams === void 0 ? void 0 : partnerParams.returnUrl) !== null && _a !== void 0 ? _a : handshakeUserDetails === null || handshakeUserDetails === void 0 ? void 0 : handshakeUserDetails.returnUrl) !== null && _b !== void 0 ? _b : '');
    if (!partnerReturnUrl)
        return '';
    const searchParams = new URLSearchParams();
    if (error) {
        searchParams.append('success', 'false');
        searchParams.append('process', 'error');
        return appendQueryParamToUrl(partnerReturnUrl, searchParams.toString());
    }
    searchParams.append('process', 'success');
    if (handshakeUserDetails === null || handshakeUserDetails === void 0 ? void 0 : handshakeUserDetails.shopName)
        searchParams.append('shopId', handshakeUserDetails.shopName);
    if (partnerParams === null || partnerParams === void 0 ? void 0 : partnerParams.state)
        searchParams.append('state', partnerParams.state);
    if (accountId)
        searchParams.append('accountId', accountId);
    if (crmId)
        searchParams.append('crmId', crmId);
    return appendQueryParamToUrl(partnerReturnUrl, searchParams.toString());
};
export const initializePartnerFlow = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const state = getState();
    const { partner: { partnerConfig, partnerKey, partnerParams, }, } = state;
    if (!partnerConfig)
        return;
    const returnUrl = (_b = (_a = partnerParams === null || partnerParams === void 0 ? void 0 : partnerParams.returnUrl) !== null && _a !== void 0 ? _a : partnerConfig.returnUrl) !== null && _b !== void 0 ? _b : '';
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');
    if (!partnerKey && (partnerConfig.isPrivateOffer || !!id)) {
        const authorizationRes = yield checkIfPartnerFlowIsAuthorized(partnerConfig.id || '', id, dispatch);
        if (!authorizationRes.ok) {
            if (returnUrl === '') {
                window.location.assign('/');
                return;
            }
            const partnerConnectorUrl = getPartnerReturnUrl({
                partnerState: state.partner,
                error: true,
            });
            openExternalLink(partnerConnectorUrl);
            return;
        }
        dispatch(setHandshakeUserDetails(authorizationRes.value));
    }
    if (id != null) {
        dispatch(setPartnerKey(id));
    }
});
